import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";

import IMVImport from "./IMVImport";
import Bewertungsmappe from "./Bewertungsmappe";
import Auswertung from "./Auswertung";
import Gutschein from "./Gutschein";
import CSVAuswertung from "./CSVAuswertung";
import Karte from "./Karte";
import LeerstandKarte from "./LeerstandKarte";

import EstateUebersicht from "./EstateUebersicht";
import Projektstatus from "./Projektstatus";

// import Mircosoft from "./msal/Microsoft";
import AuthContent from "./AuthContent";
import ResetOptions from "./ResetOptions";
import Buzzer from "./Tools/Buzzer";
import AdressUebersicht from "./AdressUebersicht";
import Einkaufsterminkarte from "./EinkaufsterminKarte";
import AkquiseAdressUebersicht from "./AkquiseAdressUebersicht";
import Nutzerauswertung from "./Nutzerauswertung";
import FotoTerminierung from "./FotoTerminierung";
import Leitfaden from "./Leitfaden";
import MyFlowCharts from "./MyFlowCharts";
import GeschaeftfuehrerMeeting from "./GeschaeftsfuehrerMeeting";
import VerkaufStatistik from "./VerkaufStatistik";
import EinkaufStatistik from "./EinkaufStatistik";
import Auktionsubersicht from "./Auktionsubersicht";
import Datenblatt from "./Datenblatt";
import News from "./News";
import Notifications from "./Notifications";
import Login from "./Login";
import RedactionUpload from "./MyRedact";
import OfflineRedact from "./MyRedact";
import NewImmopilotUser from "./NewImmopilotUser";
import Funnel from "./Funnel";
import StatistikObjektUmsatz from "./StatistikObjektUmsatz";
import Verkaufsdaten from "./Statistik/Verkaufsdaten";
import UebergabeFormular from "./Uebergabeformular/UebergabeFormular";
import BuzzerLeaderboard from "./Tools/BuzzerLeaderboard";
import MitarbeiterMemory from "./MitarbeiterMemory/MitarbeiterMemory";
import Setup from "./Setup";
import BuwogLeads from "./Tools/BuwogLeads";
import BrowserNotifications from "./BrowserNotifications";
import Nutzereinstellungen from "./Nutzereinstellungen";
import Logs from "./Logs";

export default function AppMs({
   getSiteDriveId,
   activeAccount,
   // getMsSharepointData,
   postMsSharepointNewFolder,
   updateMsSharepointNewFolder,
   handleRedirect,
   handleLogoutRedirect,
   postMsSharelink,
}) {
   const [testMode, setTestMode] = useState(() => {
      return localStorage.getItem("testMode");
   });

   return (
      <AuthProvider>
         <BrowserRouter>
            <News />
            {/* {<BrowserNotifications />} */}
            <div className="App">
               <>
                  <Routes>
                     <Route path="/login" element={<Login />} />

                     <Route element={<ProtectedRoute />}>
                        <Route path="/" element={<EstateUebersicht />} />
                        <Route path="/nutzereinstellungen" element={<Nutzereinstellungen />} />
                        <Route path="/buwogleads" element={<BuwogLeads />} />
                        <Route path="/memory" element={<MitarbeiterMemory />} />
                        <Route path="/immobilien" element={<EstateUebersicht />} />
                        <Route path="/verkaufsdaten" element={<Verkaufsdaten />} />
                        <Route path="/veranstaltungsadressen" element={<AdressUebersicht />} />
                        <Route path="/akquiseadressen" element={<AkquiseAdressUebersicht />} />
                        <Route path="/leitfaden" element={<Leitfaden />} />
                        <Route path="/leitfaden/:stage" element={<Leitfaden />} />
                        <Route path="/flowcharts" element={<MyFlowCharts />} />
                        <Route path="/uebergabeformular" element={<UebergabeFormular />} />

                        <Route
                           path="/buzzer"
                           element={
                              <Buzzer
                                 activeAccount={activeAccount}
                                 // getMsSharepointData={getMsSharepointData}
                                 handleLogoutRedirect={handleLogoutRedirect}
                                 handleRedirect={handleRedirect}
                              />
                           }
                        />
                        <Route path="/buzzerleaderboard" element={<BuzzerLeaderboard />} />
                        <Route path="/karte" element={<Karte />} />
                        <Route path="/leerstandkarte" element={<LeerstandKarte />} />
                        <Route path="/funnel" element={<Funnel />} />
                        <Route path="/gutscheine" element={<Gutschein />} />
                        <Route path="/csv" element={<CSVAuswertung />} />
                        <Route
                           path="/datenblatt"
                           element={
                              <AuthContent
                                 activeAccount={activeAccount}
                                 // getMsSharepointData={getMsSharepointData}
                                 postMsSharelink={postMsSharelink}
                                 postMsSharepointNewFolder={postMsSharepointNewFolder}
                                 updateMsSharepointNewFolder={updateMsSharepointNewFolder}
                                 handleLogoutRedirect={handleLogoutRedirect}
                                 handleRedirect={handleRedirect}
                              />
                           }
                        />
                        <Route
                           path="/datenblatt"
                           element={
                              <Datenblatt
                                 activeAccount={activeAccount}
                                 // getMsSharepointData={getMsSharepointData}
                                 postMsSharelink={postMsSharelink}
                                 postMsSharepointNewFolder={postMsSharepointNewFolder}
                                 updateMsSharepointNewFolder={updateMsSharepointNewFolder}
                              />
                           }
                        />
                        <Route path="/redact" element={<OfflineRedact />} />
                        <Route path="/setup" element={<Setup getSiteDriveId={getSiteDriveId} />} />
                        <Route path="/imv" element={<IMVImport />} />
                        <Route path="/reset" element={<ResetOptions />} />
                        <Route path="/projektstatus" element={<Projektstatus />} />
                        <Route
                           path="/fototermin"
                           element={<FotoTerminierung />}
                        />
                        <Route
                           path="/adminterminbuchung"
                           element={<GeschaeftfuehrerMeeting />}
                        />
                        <Route path="/auktionsubersicht" element={<Auktionsubersicht />} />
                        <Route path="/Einkaufsterminkarte" element={<Einkaufsterminkarte />} />
                        <Route path="/bewertungsmappe" element={<Bewertungsmappe />} />
                        {/* <Route path="/nutzerverwaltung" element={<NewImmopilotUser />} /> */}
                     </Route>

                     <Route element={<ProtectedRoute allowedRoles={["globaladmin", "admin", "editor"]} />}>
                        <Route path="/nutzerverwaltung" element={<NewImmopilotUser />} />
                     </Route>
                     <Route element={<ProtectedRoute allowedRoles={["globaladmin", "admin"]} />}>
                        <Route path="/nutzerauswertung" element={<Nutzerauswertung />} />
                     </Route>

                     <Route element={<ProtectedRoute allowedRoles={["globaladmin"]} />}>
                        <Route path="/verkaufstatistik" element={<VerkaufStatistik />} />
                        <Route path="/logs" element={<Logs />} />
                        <Route path="/einkaufstatistik" element={<EinkaufStatistik />} />
                        <Route path="/sankey" element={<StatistikObjektUmsatz />} />
                     </Route>
                  </Routes>
               </>
            </div>
         </BrowserRouter>
      </AuthProvider>
   );
}
